import React, { useState } from "react";
import { Button, Offcanvas } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import SummaryAgent from "./SummaryAgent";
import SummaryCallType from "./SummaryCallType";
import CloudIcon from "assets/svgs/cloud_icon";
import FilterIcon from "assets/svgs/filter_icon";
import { format } from "date-fns";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { BsX } from "react-icons/bs";
import DatePicker from "react-datepicker";
import { formatDate } from "modules/utilities/utility";

function SummaryModal(props) {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const handleStartDateChange = (data) => {
    setStartDate(data);
  };

  const handleEndDateChange = (data) => {
    setEndDate(data);
  };

  const handleResetStartDate = () => {
    setStartDate(null);
  };
  const handleResetEndDate = () => {
    setEndDate(null);
  };

  // const formatDate = (date) => {
  //   return format(date, "dd-MM-yyyy");
  // };
  const handleFilterSubmit = (event) => {
    event.preventDefault();

    if (props.agent.length > 0) {
      if (props.agent && props.agent?.length !== 0) {
        let agentData = props.agent
          .reduce((pre, curr) => {
            pre += curr.value + "%2C";
            return pre;
          }, "")
          .slice(0, -3);
        props.setAgentId(agentData);
      }
    } else {
      props.setAgentId("");
    }

    if (props.callType.length > 0) {
      if (props.callType && props.callType?.length !== 0) {
        let agentData = props.callType
          .reduce((pre, curr) => {
            pre += curr.value + "%2C";
            return pre;
          }, "")
          .slice(0, -3);
        props.setCallId(agentData);
      }
    } else {
      props.setCallId("");
    }
    props.setStartFilterDate(startDate);
    props.setEndFilterDate(endDate);
  };
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <div
        className="d-flex flex-row flex-wrap  gap-2 w-100"
      >
        <Form onSubmit={handleFilterSubmit} className="data-filter">
          <div className="d-flex gap-2">
            <Form.Group>
              <div className="input-container-summary mt-1" style={{zIndex:"999"}}>
                {startDate ? (
                  ""
                ) : (
                  <div className="calendar-icon-container-summary">
                    <FontAwesomeIcon
                      icon={faCalendarAlt}
                      className="calendar-icon"
                    />
                  </div>
                )}
                <DatePicker
                  selected={startDate}
                  onChange={handleStartDateChange}
                  placeholderText="Start Date"
                  dateFormat="dd-MM-yyyy"
                  value={startDate ? formatDate(startDate) : ""}
                  className="input-with-icon"
                  style={{ width: "15rem" }}
                />
                {startDate && (
                  <span className="reset-icon" onClick={handleResetStartDate}>
                    <BsX />
                  </span>
                )}
              </div>
            </Form.Group>
            <Form.Group>
              <div className="input-container-summary mt-1">
                {endDate ? (
                  ""
                ) : (
                  <div className="calendar-icon-container-summary">
                    <FontAwesomeIcon
                      icon={faCalendarAlt}
                      className="calendar-icon"
                    />
                  </div>
                )}
                <DatePicker
                  selected={startDate}
                  onChange={handleEndDateChange}
                  placeholderText="End Date"
                  dateFormat="dd-MM-yyyy"
                  value={endDate ? formatDate(endDate) : ""}
                />
                {endDate && (
                  <span className="reset-icon" onClick={handleResetEndDate}>
                    <BsX />
                  </span>
                )}
              </div>
            </Form.Group>
          </div>
        </Form>
        <div className="d-flex flex-wrap gap-2">
          <div className="mt-1">
            <SummaryAgent
              summaryUser={props.summaryUser}
              setAgent={props.setAgent}
            />
          </div>
          <div className=" mt-1" >
            <SummaryCallType setCallType={props.setCallType} />
          </div>
       
        <Button variant="primary" className=" mt-1" style={{height:"2.5rem", width:"9rem"}} onClick={handleFilterSubmit}>
          <FilterIcon /> Filter
        </Button>
        <Button variant="primary" style={{height:"2.5rem", width:"10rem"}}  className=" mt-1" type="">
          <CloudIcon /> Download
        </Button>
        </div>
      </div>
    </>
  );
}

export default SummaryModal;
